export let _Vue

export let _models = {};

export function install (Vue, options) {

  if (install.installed && _Vue === Vue) return
  install.installed = true

  _Vue = Vue

  Object.assign(_models, options.models)

  console.log("[GENS] Installing Generic API plugin");

  // const isDef = v => v !== undefined

  // Vue.mixin({
  //   $api: api, // TODO
  //   $loader: loader
  // });

  // Vue.mixin({
  //   beforeCreate () {
  //     console.log("[[[[ADDING 22]]]]");
  //     if (isDef(this.$options.loader)) {
  //       console.log("[[[[ADDING LOADER]]]]");
  //       // this._loaderRoot = this
  //       this._loader = this.$options.loader
  //       // this._loader.init(this)
  //     } else {
  //       // this._loaderRoot = (this.$parent && this.$parent._loaderRoot) || this
  //     }
  //   },
  //   destroyed () {
  //   }
  // })

  Object.defineProperty(Vue.prototype, '$db', {
    // get () { return this._loaderRoot._loader }
    get () { return this.$root.$options.db }
  })

  // DEPRECATED:
  /*
  Object.defineProperty(Vue.prototype, '$resources', {
    get () { return this.$root.$options.loader.resource_groups }
  })
  */

  if ( options && options.models ) {
    // DEPRECATED:
    // Object.defineProperty(Vue.prototype, '$api', {
    //   get () { return options.api }
    // })

    Object.defineProperty(Vue.prototype, '$models', {
      get () { return options.models }
    })
  }

  if ( options && options.api ) {
    Object.defineProperty(Vue.prototype, '$api', {
      get () { return options.api }
    })
  }

  if ( process.env.VUE_APP_PRODUCTION === 'false' && process.browser ) {
    // window.$api = options.api;
    window.$models = options.models;
    window.$api = options.api;
  }

  // TODO: Vue.util.defineReactive(this, '_route', this._loader.history.current)
}
